import React, { Component } from 'react';
import { arrayOf, string, objectOf } from 'prop-types';
import {
  adTypeShape,
  TYPE_LIVE_READ,
  TYPE_PRE_RECORDED,
  TYPE_WATCHLIST
} from '../constants';
import HorizontalBarChart from '../../../HorizontalBarChart';

import styles from './styles.scss';

export class PlacementAdTypeChart extends Component {
  static propTypes = {
    data: arrayOf(adTypeShape),
    xAxisTitle: string,
    selectedDataType: string,
    columnColors: objectOf(string)
  };

  static defaultProps = {
    data: [],
    columnColors: {
      [TYPE_LIVE_READ.id]: '#3F51B5',
      [TYPE_PRE_RECORDED.id]: '#d62bd6',
      [TYPE_WATCHLIST.id]: '#00bcd4'
    }
  };

  prepChartData() {
    const { data, selectedDataType, columnColors } = this.props;

    return data.reduce((accum, currEntry) => {
      const { type_name, type_id } = currEntry;
      const decimal = selectedDataType === 'visitOfads' ? 2 : 1;
      accum.push({
        x: parseFloat(currEntry[selectedDataType].toFixed(decimal)),
        y: type_name,
        fillColor: columnColors[type_id]
      });

      return accum;
    }, []);
  }

  render() {
    const { xAxisTitle } = this.props;
    const chartData = this.prepChartData();

    return (
      <div data-test="placementAdTypeChart" className={styles.placementAdTypeChart}>
        <HorizontalBarChart
          data={chartData}
          xAxisTitle={xAxisTitle}
        />
      </div>
    );
  }
}
